import React from 'react';
import { Card as _Card, Row as _Row, Col } from 'antd';
import { compose, withHandlers, withStateHandlers } from 'recompose';
import styled from 'styled-components';
import { pick } from 'lodash';

import { TextInput, Dropdown } from 'components/Core/Forms';
import { BlueButton } from 'components/Core/Buttons';

const cities = [
  { label: 'All', value: 'all' },
  { label: 'Bangkok', value: 'Bangkok' },
  { label: 'Phuket', value: 'Phuket' },
  { label: 'Chiang Mai', value: 'Chiang Mai' },
];

const productTypes = [
  { label: 'All', value: 'all' },
  { label: 'Trip', value: 'trip' },
  { label: 'Ticket', value: 'ticket' },
  { label: 'Souvenir', value: 'souvenir' },
  { label: 'Car Rental', value: 'car_rental' },
];

const getQueryObject = props => pick(props, ['name', 'city', 'productType']);

const Row = styled(_Row)`
  ${props => !props.noPad && 'margin-bottom: 15px;'}
`;

const Card = styled(_Card)`
  margin: 0 -25px !important;
  border: none !important;
`;

const enhance = compose(
  withStateHandlers(
    { name: '', city: 'all', productType: 'all' },
    {
      setField: filterState => (field, value) => ({
        ...filterState,
        [field]: value
      })
    }
  ),
  withHandlers({
    onChangeName: props => e => {
      props.setField('name', e.target.value);
      const query = {
        ...getQueryObject(props),
        name: e.target.value
      };
      props.onQueryChange(query);
    },
    onChangeDropdown: props => field => v => {
      props.setField(field, v);
      const query = {
        ...getQueryObject(props),
        [field]: v
      };
      props.onQueryChange(query);
    },
    onClick: props => async () => {
      await props.onSearch();
      if (props.onSearchSuccess) {
        props.onSearchSuccess();
      }
      props.setField('name', '');
      props.setField('city', 'all');
      props.setField('productType', 'all');
      props.onQueryChange({
        name: '',
        city: 'all',
        productType: 'all'
      });
    }
  })
);

const ProductSearch = props => {
  const { name, city, productType } = props;
  return (
    <Card>
      <Row gutter={16}>
        <Col sm={24} md={12}>
          <TextInput
            value={name}
            onChange={props.onChangeName}
            type="text"
            label="Name"
            onPressEnter={() => props.onClick()}
          />
        </Col>
        <Col sm={12} md={6}>
          <Dropdown
            value={city}
            onChange={props.onChangeDropdown('city')}
            options={cities}
            label="City"
          />
        </Col>
        <Col sm={12} md={6}>
          <Dropdown
            value={productType}
            onChange={props.onChangeDropdown('productType')}
            options={productTypes}
            label="Product Type"
          />
        </Col>
      </Row>
      <Row gutter={16} noPad>
        <Col>
          <BlueButton icon="search" onClick={props.onClick}>Search</BlueButton>
        </Col>
      </Row>
    </Card>
  );
};

export default enhance(ProductSearch);



// WEBPACK FOOTER //
// ./src/components/Product/ProductSearch.js